import React from 'react';
import galleryImages from '../data/galleryImages';
import './GalleryPreview.css';

const GalleryPreview = ({ openGallery }) => {
  const previewImages = galleryImages.slice(0, 16);

  return (
    <section id="gallery-preview" className="gallery-preview section">
      <div className="container">
        <div className="gallery-preview-header animate-fade-in-up">
          <p className="gallery-kicker">Product Gallery</p>
          <h2 className="section-title">See Our Workwear Range</h2>
          <p>
            Browse a selection of Totalguard Workwear Rosslyn products, from protective clothing
            and safety footwear to technical wear built for demanding work environments.
          </p>
        </div>

        <div className="gallery-preview-grid animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          {previewImages.map((image, index) => (
            <button
              className={`gallery-preview-tile gallery-preview-tile-${index + 1}`}
              key={image.id}
              type="button"
              onClick={openGallery}
              aria-label="View full product gallery"
            >
              <img src={image.src} alt={image.alt} loading="lazy" />
            </button>
          ))}
        </div>

        <div className="gallery-preview-action animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <button type="button" className="btn" onClick={openGallery}>
            View Full Gallery
          </button>
        </div>
      </div>
    </section>
  );
};

export default GalleryPreview;
